import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IAuthorization } from '@obvious.tech/constellation'

export const Authorization = defineEntity('Authorization', {
  endpoint: 'authentication/api/Authorization',
  schema: SNoop<IAuthorization>(),
})
